import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "Brunnenwasser",
    link: "/brunnenwasser",
    imgUrl: "/content/uploads/2018/08/brunnen-1.png"
  },
  {
    title: "Regenwasser",
    link: "/regenwasser",
    imgUrl: "/content/uploads/2018/08/regen.png"
  },
  {
    title: "Schmutzwasser",
    link: "/schmutzwasser",
    imgUrl: "/content/uploads/2018/08/schmutzwasser.png"
  },
  {
    title: "Abwasser",
    link: "/abwasser",
    imgUrl: "/content/uploads/2018/08/toilette.png"
  },
]

export function Home() {
  return (
    <Questionnaire question={"Wofür benötigen Sie Ihre neue Pumpe?"} icons={icons}/>
  );
}